var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45508 11.1609V18.108H18.674V6.5007C15.7664 8.77437 11.873 10.434 7.45508 11.1609ZM21.3294 6.5007V18.108H32.5451V11.1609C28.1272 10.434 24.2337 8.77437 21.3294 6.5007ZM21.3294 20.7634V33.4993C26.9522 32.779 31.4663 27.5114 32.3758 20.7634H21.3294ZM7.62436 20.7634C8.53383 27.515 13.0513 32.779 18.674 33.4993V20.7634H7.62436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.fd46a057ca136ca1a4d13699a92ea1fb.svg";
export { ForwardRef as ReactComponent };